'use strict';

/**
 * @generated SignedSource<<59eda13f5b201a377acbeb8a7271b6fc>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cartId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "channel"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountNumber",
        "storageKey": null
    }, v2 = {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AccountList",
                "kind": "LinkedField",
                "name": "accountList",
                "plural": true,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "segment",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cartId",
            "variableName": "cartId"
        },
        {
            "kind": "Variable",
            "name": "channel",
            "variableName": "channel"
        }
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useAvailableAccountsQuery",
            "selections": [
                (v2 /*: any*/),
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "CartView",
                    "kind": "LinkedField",
                    "name": "cartView",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Cart",
                            "kind": "LinkedField",
                            "name": "cart",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useAvailableAccountsQuery",
            "selections": [
                (v2 /*: any*/),
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "CartView",
                    "kind": "LinkedField",
                    "name": "cartView",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Cart",
                            "kind": "LinkedField",
                            "name": "cart",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "8804bac6e6ee3ac53470db4ee6f3bc96",
            "id": null,
            "metadata": {},
            "name": "useAvailableAccountsQuery",
            "operationKind": "query",
            "text": "query useAvailableAccountsQuery(\n  $cartId: String!\n  $channel: CartChannel!\n) {\n  me {\n    accountList {\n      accountNumber\n      firstName\n      lastName\n      segment\n    }\n  }\n  cartView(cartId: $cartId, channel: $channel) {\n    cart {\n      accountNumber\n      id\n    }\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "afe4ef8545cac4feb72cab210a98c663";

module.exports = node;
